import React from 'react'
import pagelogo from 'assets/pinnacle/pinnacle-logo.png'

export default function BannerMobile() {
  return (
    // <div className="bg-[#371101] bg-[url('assets/pinnacle/banner/bgMob.jpg')] h-[650px] bg-center bg-cover bg-no-repeat">
    <div className="bg-[#371101] bg-[url('assets/pinnacle/banner/pm.png')] min-[500px]:bg-[url(assets/pinnacle/banner/pmd.jpg)] h-[650px] bg-[60%_50%] min-[500px]:bg-[70%_0%] bg-cover bg-no-repeat">
      <div className="flex items-end h-full blade-bottom-padding">
        <div className="relative max-w-3xl px-3 2xl:max-w-4xl w-container-sm blade-top-padding">
          <div className="flex flex-col items-start justify-center gap-0  grow-0 shrink">
            <div className="h-[52px] w-[120px] md:h-14 lg:h-16  ">
              <img
                className="object-cover h-full w-fit"
                src={pagelogo}
                alt="logo of premier elite"
              />
            </div>

            <div>
              <h3
                style={{
                  backgroundImage:
                    'linear-gradient(186deg, #FFF -96.64%, #F69A4D 109.37%)',
                }}
                className="font-medium text-transparent bg-clip-text"
              >
                Pinnacle
              </h3>
            </div>
          </div>

          <div className="w-full h-[2px] bg-orange rounded-full max-w-[150px] mb-5 mt-3"></div>

          <div className="flex-col items-start flex-1 text-white">
            <h6 className="leading-snug font-regular ">
              Fixed, Flat-Panel, Fully Digital Cath Lab
            </h6>
            <ol className="mt-3 text-sm font-light list-disc pl-7">
              <li>Real time image acquisition</li>
              <li>1024x1024 high-resolution image</li>
              <li>Smallest footprint</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  )
}
